import ExpanderAnimation from './ExpanderAnimation';

export default ExpanderAnimation;
